import { useTopCategory } from "./useTopCategory";

export function useTopCategoryName() {
  const topCategory = useTopCategory();
  return topCategory?.name;
}
